import React from 'react'
import { View, ViewProps } from 'react-native'

export interface Props extends ViewProps {
  style?: ViewProps['style'] & { tintColor?: string }
  tintColor?: string
  triggersDefaultCastDialog?: boolean
  onPress?: () => void
}

// TODO: temporary solution for web, need to be resolved
export default function CastButton(props: Props) {
  return <View {...props} />
}
